<!--  -->
<template>
  <div class="head-nav sticky">
    <div class="logo-box">
        <a href="/" class="logo" title="测评系统"><img :src="`/static/img/logo.jpg?t=${Math.random()}`" alt="logo"></a>    
    </div>
    <nav class="main-menu">
      <ul>
          <li style="margin-right:5%;">
              <router-link to="/">首页</router-link>
          </li>
      
          <li style="margin-right:5%;">
              <router-link to="/papercenter">测评中心</router-link>
          </li>
          <li style="margin-right:5%;">
                <router-link to="/examrecord">测评记录</router-link>
            </li>
          <li style="margin-right:5%;">
              <router-link to="/courviews">课程学习</router-link>
          </li>
          <li style="margin-right:5%;">
              <router-link to="/mistakelist">错题本</router-link>
          </li>      
          <li>
              <router-link to="/liveview">直播中心</router-link>
          </li>
      </ul>
    </nav>
    <div class="search-box">
        <input type="search" v-model="searchWords" placeholder="搜索课程">
        <button type="submit" @click="search()"><img src="/static/img/search-line.png" width="21" height="21"/></button>
    </div>
    <el-button  @click="EnterPerson()" class="personcenter" :id="$route.path == '/personcenter'&&'personcenter'" round :style="`${$route.path == '/personcenter' ? 'background-color: rgb(255 0 0 / 50%) !important;padding:0 !important;' : ''}`">{{ $route.path == "/personcenter" ? '退出登录' : user().name ? user().name : '登录' }}</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchWords: "",
      searchType: "3"
    };
  },
  methods: {
    user() {
      return this.$store.getters.user;
    },
    EnterPerson(){
        if(this.$route.path=="/personcenter"){
             localStorage.removeItem("eleTokenWrd001");
            this.$store.dispatch("clearCurrentState");
            // 页面跳转
            this.$router.push("/login");
        }
        else{
            this.$router.push("/personcenter");
        }
    },
    search() {
      if (this.searchType == "3") {
        this.$router.push("/courviews?searchWords=" + this.searchWords);
      }
    }
  },
};
</script>
<style scoped>
.head-nav{
  position: sticky;
  top:0;
  width: 100%;
  height: 88px;
  z-index: 99999;
  background-color:#ffffff;
}
.head-nav .logo-box{
  position: relative;
  width: 1200px;
  height: 88px;
  margin: 0 auto;
  display: flex;
  justify-content: start;
}
.logo-box .logo img {
  margin-top: 18px;
margin-bottom: 20px;
margin-left: 1px;
}
.main-menu li {
    cursor:pointer;
}
.main-menu li:hover a{
    color: #4462CF;
}
.search-box{
  position: absolute;
  top: 0;
  right: 174px;
  margin-top: 24px;
  margin-left: 53px;
  width: 231px;
height: 44px;
background: #F4F4F4;
border-radius: 5px;
}

.search-box input{
  border: 0;
  width: 200px;
  background: #F4F4F4;
  padding-left:19px;
  padding-right: 12px;;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
}
.search-box input::placeholder{
  color: #ADADAD;
}
.search-box input[type="search"] {
  height: 44px;
}
.search-box button {
  background: #F4F4F4;
  border: 0;
  height: 44px;
  line-height: 44px;
}
.search-box img{
  margin-top: 0px;
  margin-left: 0px;
}
.search-boxbutton{
  padding: 0;
}
</style>
